import isString from 'lodash/isString';
import {z} from 'zod';
import {getBaseZodType, isZodString} from '../../../common/zodForm/helper';
import {FormField} from '../../../common/zodForm/type';

/**
 * schema에 필수값으로 설정된 필드를 찾아서 값이 입력되었는지 확인합니다.
 */
export function getRequiredFieldFilled({
  formFields,
  value,
}: {
  formFields: FormField[];
  value: Record<string, unknown>;
}) {
  return formFields.every(field => {
    if (field.required && isNonEmptyStringSchema(field.schema)) {
      return (
        isString(value[field.key]) &&
        (value[field.key] as string).trim().length > 0
      );
    }
    return true;
  });
}
function isNonEmptyStringSchema(schema: z.ZodTypeAny): boolean {
  /**
   * 현재 schema가 zodTypeAny로 타이핑 되어있는데, 실제로는 zodEffects다.
   * zod.ZodEffects에서 내부 schema를 재귀적으로 추출하여 타입을 확인할 수 있다.
   * TODO(@harry-hi): 추후 schema를 zodEffect로 타이핑 수정 필요함.
   */
  const _schema = getBaseZodType(schema);
  if (isZodString(_schema)) {
    return _schema._def.checks.some(
      check => check.kind === 'min' && check.value >= 1
    );
  }
  return false;
}
